import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { useHistory } from 'react-router-dom';
import cs from './index.module.scss';

const Profile: React.FC = () => {
  const { t } = useTranslation();
  const { account,ui } = useStore();
  const { isLogin } = account;
  const { push } = useHistory();

  return (
    <div className={cx(cs.container)}>
      {!isLogin ? (
        <>
          <a
            className={cx(cs.login)}
            onClick={() => {
              // push('/login');
              ui.showLoginModal()
            }}
          >
            {t('btn.signIn')}
          </a>

          <a
            className={cx(cs.register)}
            onClick={() => {
              // push('/register');              
              ui.showRegisterModal()
            }}
          >
            {t('btn.signUp')}
          </a>
        </>
      ) : null}

      {/* <div>{visible && <OpenAccountModal visible={visible} hideModel={hideOpenAccountModal} />}</div> */}
    </div>
  );
};

export default observer(Profile);
